import { Slide } from '@/components/core/Slide';
import videoFile from './16-bubbles.webm';
import qrLinkedIn from '/assets/images/qr-LinkedIn.png';

export const slide = () => {
  return (
    <Slide
      notes="EVA video demonstration"
      visualizer="full"
      background={{
        video: videoFile,
      }}
    >
      <div className="relative z-10 flex items-center justify-center h-full">
        <h1 className="text-8xl font-light text-white tracking-wider">EVA</h1>
      </div>
      <div className="fixed right-[14%] top-1/2 z-20" style={{ transform: 'translateY(-50%)' }}>
        <img src={qrLinkedIn} alt="LinkedIn QR Code" className="w-96 object-contain" />
      </div>
    </Slide>
  );
};
